import {combineReducers} from '@reduxjs/toolkit';
import asset from './asset/reducer';
import authen from './authen/reducer';
import investment from './investment/reducer';
import languages from './languages/reducer';
import portal from './portal/reducer';
import transaction from './transaction/reducer';

export const rootReducer = combineReducers({
  authen,
  languages,
  transaction,
  investment,
  asset,
  portal,
});
export type RootState = ReturnType<typeof rootReducer>;

// export *
